import React from "react";
import { Badge, Tile, Mono, CopyBtn } from "@/components/primitives";
import { truncMid, unixToDate } from "@/lib/format";

// ---------- Metadata mode summary panel ----------
// Metadata labels don't have a single "object" endpoint (mirrors Blockfrost,
// which also only exposes label + paginated tx list) — so this panel is built
// from the same first-page probe `runQuery` already fetched, rather than a
// dedicated summary endpoint.
export const MetadataSummaryPanel = ({ data, onPickTx }) => {
  if (!data) return null;
  const sample = data.sample;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="metadata-summary-panel">
      <Tile
        testid="metadata-tile-label"
        label="Label"
        value={<Mono>{data.label}</Mono>}
        hint="CIP-10 metadata registry number"
      />
      <Tile
        testid="metadata-tile-status"
        label="Usage"
        value={
          data.has_entries ? (
            <Badge tone="success">used on-chain</Badge>
          ) : (
            <Badge tone="warn">no records found</Badge>
          )
        }
      />
      <Tile
        testid="metadata-tile-sample"
        label="Most recent tx"
        value={
          sample ? (
            <span className="inline-flex items-center gap-2">
              <button
                type="button"
                data-testid="metadata-sample-tx-link"
                onClick={() => onPickTx?.(sample.tx_hash)}
                className="text-primary text-glow hover:underline decoration-dotted underline-offset-2"
              >
                {truncMid(sample.tx_hash, 12, 6)}
              </button>
              <CopyBtn value={sample.tx_hash} label="sample-tx" />
            </span>
          ) : (
            <span className="text-muted-foreground">—</span>
          )
        }
        hint={sample ? unixToDate(sample.block_time) : null}
      />
    </div>
  );
};
